<div class="page-padding">
  <div class="panel" *ngIf="!showAddnewPanelForObservation">
    <div class="panel__header">
      <span class="panel__header__title">{{'Manage Observation Lists' | translate | async}}</span>
    </div>
    <!-- <div style="margin-left: 25px;"><span style="font-size: 17px;">Select a Customer</span></div>
    <div *ngIf="isShowCustomer" class="panel__sub-header" style="display: block;">
      <div class="input-container" style="margin-left: 1%">
        <span class="label">Customer Name</span>
        <mat-form-field class="header-form-full-width">
          <mat-label>Customer Name</mat-label>
          <input type="text" matInput [(ngModel)]="selectedCustomer" (input)="filterUsers($event)">
        </mat-form-field>
      </div>
    </div> -->
    <div class="inline-row">
      <!-- CUSTOMER -->
      <div class="inline-item">
        <mat-form-field class="header-form-full-width">
          <mat-label>{{"Customer Name" | translate | async}} *</mat-label>
          <input type="text" matInput [matAutocomplete]="auto" [(ngModel)]="selectedCustomerName"
            (input)="filterCustomers()" (focus)="showAllCustomers()">
        </mat-form-field>

        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectCustomer($event)">
          <mat-option class="mat-option-dropdown-panel" *ngFor="let customer of filteredCustomers"
            [value]="customer.Name">
            {{ customer.Name }}
          </mat-option>
        </mat-autocomplete>
      </div>
      <!-- FAMILY -->
      <div class="inline-item">

        <mat-form-field class="header-form-full-width">
          <mat-label>{{'Family' | translate | async}}</mat-label>
          <input type="text" matInput [matAutocomplete]="familyAuto1" [(ngModel)]="selectedFamilyName"
            (ngModelChange)="onFamilyInputChange($event)" (focus)="showAllFamilies()" />
        </mat-form-field>

        <mat-autocomplete #familyAuto1="matAutocomplete" (optionSelected)="selectFamily($event)">
          <!-- Use the filtered list here -->
          <mat-option *ngFor="let fam of filteredFamilies" [value]="fam.Name">
            {{ fam.Name }}
          </mat-option>
        </mat-autocomplete>

      </div>
      <!-- SEARCH & RESET BUTTONS -->
      <div class="inline-item button-container" style="margin-left:75px;">
        <a class="button button--secondary" (click)="resetFilters()">
          <i class="material-icons button__icon">refresh</i>
          <span class="button__text">{{'Reset' | translate | async}}</span>
        </a>
        <a class="button button--primary" (click)="onClick()">
          <i class="material-icons button__icon">search</i>
          <span class="button__text">{{'Search' | translate | async}}</span>
        </a>
      </div>
    </div>

    <div class="panel__content no-padding">
      <div>
        <div class="grid-top-header">
          <span class="panel__header__title" style="margin-left: 25px;
          font-size: 18px;">{{'Observation Lists' | translate | async}}</span>
          <button mat-raised-button color="warn" *ngIf="showbutton" (click)="ShowAddNewObservation()">
            <span class="material-icons button__icon">add</span>
            <span class="button__text">{{'Add New' | translate | async}}</span>
          </button>
          <!-- <a class="button button--primary" style="margin-left: 75%;; margin-bottom: 20px;" > <i class="material-icons button__icon" (click)="ShowAddNewObservation()">add</i><span
                 class="button__text" (click)="ShowAddNewObservation()"> Add New</span></a> -->
        </div>
        <div>
          <table class="table table--striped table--full-width">
            <thead>
              <th class="text-left text-padding">{{'Name' | translate | async}}</th>
              <th class="text-center text-padding">{{'Number of Observations' | translate | async}}</th>
              <th class="text-center text-padding">{{'Family' | translate | async}}</th>
              <th class="text-center text-padding">{{'Components Currently Using' | translate | async}}</th>
              <th class="text-center text-padding">{{'Crack Obs. List' | translate | async}}</th>
              <th class="text-center text-padding">{{'Crack Severity List' | translate | async}}</th>
              <th class="text-center text-padding">{{'Active' | translate | async}}</th>
              <th class="text-left text-padding">{{'Edit' | translate | async}}</th>
            </thead>
            <tbody *ngIf="showObservationListTable==true">
              <tr *ngFor="let observation of ObservationList">
                <td class="text-left">{{observation.name}}</td>
                <td class="text-center">{{observation.numberOfObservations}}</td>
                <td class="text-center">{{observation.FamName}}</td>
                <td class="text-center">(0)</td>
                <td class="text-center"><mat-checkbox [(ngModel)]="observation.CrackObsList"
                    [disabled]="observation.CrackSeverityList === true"
                    (change)="setObsListFlag(observation.observationList_auto, $event)"></mat-checkbox>
                </td>
                <td class="text-center"><mat-checkbox [(ngModel)]="observation.CrackSeverityList"
                    [disabled]="observation.CrackObsList === true"
                    (change)="setCrackSeverityListFlag(observation.observationList_auto, $event)"></mat-checkbox>
                </td>
                <td class="text-center">
                  <mat-checkbox [(ngModel)]="observation.active"
                    (change)="deleteObservationList(observation.observationList_auto, $event)"></mat-checkbox>
                </td>
                <td class="text-left">
                  <i class="material-icons button__icon cursor-pointer"
                    (click)="getObservationforCustomer(observation.observationList_auto, observation.name, observation.CrackSeverityList)">edit</i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="showObservationListTable==false">
          <span> {{'There are no observation lists created for this customer. Click Add New to create one.' | translate
            | async}}</span>
        </div>
      </div>
    </div>
    <!-- <div class="panel__content no-padding">
      <div style="overflow-y: auto; height:fit-content;margin-top: 10px; ">
        <table class="table table--striped table--full-width">
          <thead>
            <th style="text-align: left;">Customer Name</th>
          </thead>
          <tbody>
            <tr>
              <td style="text-align: left; cursor: pointer;"
                (click)="AddnewObservationtoSelectedCus(selectedCustomer.Id, selectedFamily?.Id)">
                {{displayCustomerName}}</td>
            </tr> -->
    <!-- <tr *ngFor="let cus of customerList">
              <td style="text-align: left; cursor: pointer;" (click)="AddnewObservationtoSelectedCus(cus.Id)">
                {{cus.Name}}</td>
            </tr> -->
    <!-- </tbody>
        </table>
      </div>
    </div> -->
  </div>

  <div class="panel" *ngIf="showAddnewPanel==true">
    <div class="panel__header">
      <span class="panel__header__title">{{'Setup New List' | translate | async}}</span>
    </div>
    <div class="input-container margin-left">
      <span class="label text-width">{{'List Name' | translate | async}} *</span>
      <mat-form-field class="header-form-width">
        <mat-label>{{'General Bucket Observations' | translate | async}}</mat-label>
        <input type="text" matInput [(ngModel)]="selectedListName" required>
      </mat-form-field>
    </div>
    <div class="input-container margin-left">
      <span class="label text-width">{{'Add Observation' | translate | async}}</span>
      <mat-form-field class="header-form-width">
        <mat-label>{{'Enter Observation and Press Add' | translate | async}}</mat-label>
        <input type="text" matInput [(ngModel)]="selectedObservationName">
      </mat-form-field>
      <button mat-raised-button color="warn" (click)="AddObservationtoArray()">
        <span class="material-icons button__icon">add</span>
        <span class="button__text">{{'Add' | translate | async}}</span>
      </button>
      <!-- <a class="button button--primary" ><i class="material-icons button__icon" >add</i><span
        class="button__text" (click)="AddObservationtoArray()" > Add</span></a> -->
    </div>
    <div class="input-container margin-left">
      <span class="label text-width">{{'Family' | translate | async}}</span>
      <mat-form-field class="header-form-width">
        <mat-label>{{'Family' | translate | async}}</mat-label>
        <input type="text" matInput [matAutocomplete]="familyAuto2" [(ngModel)]="selectedFamilyName"
          (ngModelChange)="onFamilyInputChange($event)" (focus)="showAllFamilies()" />
      </mat-form-field>

      <mat-autocomplete #familyAuto2="matAutocomplete" (optionSelected)="selectFamily($event)">
        <mat-option *ngFor="let fam of filteredFamilies" [value]="fam.Name">
          {{ fam.Name }}
        </mat-option>
      </mat-autocomplete>

    </div>
    <div class="panel__content no-padding">
      <div class="overflow-div">
        <table class="table table--striped table--full-width">
          <thead>
            <th class="text-left text-padding">{{'Observation List' | translate | async}}</th>
          </thead>
          <tbody>
            <tr *ngFor="let ob of arr, let i =  index">
              <td class="text-left cursor-pointer">{{ob}}</td>
              <td>
                <!-- <i class="material-icons button__icon" style="cursor: pointer;" (click)="deletefromArray(i)">delete</i>      -->
                <i class="material-icons button__icon" style="cursor: pointer;"
                  (click)="deletefromArrayNewList(ob,i)">delete</i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="button-style">
      <a class="button button--primary" (click)="goBack()">
        <i class="material-icons button__icon">arrow_back</i><span class="button__text">
          {{'Cancel' | translate | async}}</span>
      </a>
      <a class="button button--primary" (click)="AddNewObservation()">
        <i class="material-icons button__icon">save</i><span class="button__text">
          {{'Save' | translate | async}}</span>
      </a>
    </div>
  </div>

  <div class="panel" *ngIf="showEditObservationTable==true">
    <div class="panel__header">
      <span class="panel__header__title">{{'Edit Observation List' | translate | async}}</span>
    </div>
    <div class="input-container margin-left">
      <span class="label text-width">{{'List Name' | translate | async}} *</span>
      <mat-form-field class="header-form-width">
        <mat-label>{{'List Name' | translate | async}}</mat-label>
        <input type="text" matInput [(ngModel)]="selectedListName" (ngModelChange)="detectChange()" required>
      </mat-form-field>
    </div>
    <div class="input-container margin-left">
      <span class="label text-width">{{'Add Observation' | translate | async}}</span>
      <mat-form-field class="header-form-width">
        <mat-label>{{'Add Observation' | translate | async}}</mat-label>
        <input type="text" matInput [(ngModel)]="selectedObservationNameforList">
      </mat-form-field>
      <a class="button button--primary">
        <span class="button__text" (click)="AddObservationListtoArray()"> {{'Add/Update' | translate | async}}</span>
      </a>
      <!-- <a class="button button--primary" ><span
        class="button__text" (click)="AddNewObservationToList()" > Add/Update</span></a>
      </div> AddObservationListtoArray -->
    </div>
    <div class="input-container margin-left">

      <span class="label text-width">{{'Family' | translate | async}}</span>

      <mat-form-field class="header-form-width">
        <mat-label>{{'Family' | translate | async}}</mat-label>
        <input type="text" matInput [matAutocomplete]="familyAuto3" [(ngModel)]="selectedFamilyName"
          (ngModelChange)="onFamilyInputChange($event)" (focus)="showAllFamilies()" />
      </mat-form-field>

      <mat-autocomplete #familyAuto3="matAutocomplete" (optionSelected)="selectFamily($event)">
        <!-- IMPORTANT: use filteredFamilies (not familyList) -->
        <mat-option *ngFor="let fam of filteredFamilies" [value]="fam.Name">
          {{ fam.Name }}
        </mat-option>
      </mat-autocomplete>

    </div>
    <div class="panel__content no-padding">
      <div class="overflow-div">
        <table class="table table--striped table--full-width">
          <thead>
            <th class="text-width2 text-left text-padding">{{'Observaton' | translate | async}}</th>
            <th class="text-center">{{'Active' | translate | async}}</th>
            <th *ngIf="showColorPicker" class="text-center">{{'Color' | translate | async}}</th>
            <th *ngIf="showColorPicker" class="text-center">{{'Color Include In Report' | translate | async}}</th>
            <th class="text-center">{{'Edit' | translate | async}}</th>
          </thead>
          <tbody>
            <tr *ngFor="let ob of observation, let i =  index">
              <td *ngIf="editingIndex !== i" class="text-left cursor-pointer">{{ob.observation}}</td>
              <td *ngIf="editingIndex === i && ob.observation_auto === 0 && ob.observation?.trim()"
                class="text-left cursor-pointer">
                {{ob.observation}}</td>
              <td *ngIf="editingIndex === i && ob.observation_auto > 0">
                <input #txt type="textarea" name="field" (focusout)="EditObservation(ob)"
                  [(ngModel)]="ob.observation" />
              </td>
              <td class="text-center" *ngIf="ob.observation?.trim()">
                <mat-checkbox [(ngModel)]="ob.active "
                  (change)="onObservationActiveChange(ob, $event.checked)"></mat-checkbox>
              </td>
              <!-- Color -->
              <td *ngIf="showColorPicker">
                <div class="color-container">
                  <input type="text" maxlength="7" placeholder="#FFFFFF" [(ngModel)]="ob.ColorCode"
                    (ngModelChange)="isChange = true" class="color-input">
                  <div [colorPicker]="tempColor" (colorPickerOpen)="openColorPicker(ob)"
                    (colorPickerSelect)="applyColor($event, ob)" [cpOKButton]="true" [cpCancelButton]="true"
                    [style.background]="ob.ColorCode" class="color-box">
                  </div>
                </div>
              </td>
                <!-- Include Color In Report -->
                <td class="text-center" *ngIf="showColorPicker">
                  <mat-checkbox [(ngModel)]="ob.ColorIncludeInReport" (change)="onColorIncludeChange(ob, $event.checked)">
                  </mat-checkbox>
                </td>
                <td class="text-center">
                  <!-- Edit (existing only) -->
                  <ng-container *ngIf="ob.observation_auto > 0 && !ob.isNew">
                    <i class="material-icons button__icon" style="cursor: pointer;"
                      (click)="ShoweditObservation(ob,i)">edit</i>
                  </ng-container>
                  <!-- Delete (new only) -->
                  <ng-container *ngIf="ob.isNew">
                    <i class="material-icons button__icon" style="cursor: pointer;"
                      (click)="deletefromArray(i)">delete</i>
                  </ng-container>
                </td>
                <!--<i class="material-icons button__icon" (click)="deletefromArray(i);deleteObservation(ob.observation_auto, ob.observation_list_auto);">delete</i>-->
                <!-- <td class="text-center">
                <ng-container *ngIf="ob.observation_auto>0">
                  <i class="material-icons button__icon" style="cursor: pointer;"
                    (click)="ShoweditObservation(ob,i)">edit</i>
                </ng-container>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="button-style">
      <a class="button button--primary" (click)="goBack()">
        <i class="material-icons button__icon">arrow_back</i><span class="button__text">
          {{'Cancel' | translate | async}}</span>
      </a>
      <a class="button button--primary" (click)="AddNewObservationToList()">
        <i class="material-icons button__icon">save</i><span class="button__text">
          {{'Save' | translate | async}}</span>
      </a>
    </div>
  </div>
</div>